var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "header" },
    [
      _c("div", { staticClass: "header-primary" }, [
        _c(
          "div",
          { staticClass: "container header-primary__inner" },
          [
            _c(
              "nuxt-link",
              { staticClass: "header-primary__logo", attrs: { to: "/" } },
              [
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/Vixio_Logo_White.svg"),
                    alt: "Payments Compliance",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-primary__search",
                class: { show: _vm.showSearch },
              },
              [_c("Search")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-primary__right" },
              [
                _vm.isAuthorize
                  ? _c(
                      "div",
                      {
                        staticClass: "header-utility",
                        on: {
                          mouseover: function ($event) {
                            _vm.regDataOpen = true
                          },
                          mouseleave: function ($event) {
                            _vm.regDataOpen = false
                          },
                        },
                      },
                      [
                        _c("button", { staticClass: "header-utility__btn" }, [
                          _vm._v("\n            REGULATORY DATA\n            "),
                          _c(
                            "svg",
                            {
                              staticClass: "header-utility__chevron",
                              class: { open: _vm.regDataOpen },
                              attrs: {
                                width: "10",
                                height: "6",
                                viewBox: "0 0 10 6",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M1 1l4 4 4-4",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.regDataOpen,
                                expression: "regDataOpen",
                              },
                            ],
                            staticClass: "header-utility__dropdown",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "header-utility__dropdown-current",
                              },
                              [_vm._v("Payments Compliance")]
                            ),
                            _vm._v(" "),
                            _vm.otherVerticalSubs.financial_services &&
                            _vm.otherVerticalSubs.financial_services.active
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "header-utility__dropdown-item",
                                    attrs: { href: _vm.fsUrl },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Financial Services\n            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "header-utility__dropdown-item header-utility__dropdown-item--disabled",
                                  },
                                  [
                                    _vm._v(
                                      "\n              Financial Services\n            "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "header-utility__dropdown-item header-utility__dropdown-item--disabled",
                                attrs: { href: "#" },
                              },
                              [
                                _vm._v(
                                  "\n              GamblingCompliance\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAuthorize
                  ? _c(
                      "div",
                      {
                        staticClass: "header-utility",
                        on: {
                          mouseover: function ($event) {
                            _vm.workspaceOpen = true
                          },
                          mouseleave: function ($event) {
                            _vm.workspaceOpen = false
                          },
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "header-utility__btn",
                            on: {
                              click: function ($event) {
                                _vm.workspaceAccess ? null : undefined
                              },
                            },
                          },
                          [
                            _vm._v("\n            WORKSPACE\n            "),
                            _c(
                              "svg",
                              {
                                staticClass: "header-utility__chevron",
                                class: { open: _vm.workspaceOpen },
                                attrs: {
                                  width: "10",
                                  height: "6",
                                  viewBox: "0 0 10 6",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M1 1l4 4 4-4",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.workspaceOpen,
                                expression: "workspaceOpen",
                              },
                            ],
                            staticClass: "header-utility__dropdown",
                          },
                          [
                            _vm.workspaceAccess
                              ? [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "header-utility__dropdown-item",
                                      attrs: {
                                        href: "https://ws.vixio.com/triage",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                      },
                                    },
                                    [_vm._v("Triage")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "header-utility__dropdown-item",
                                      attrs: {
                                        href: "https://ws.vixio.com/boards",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                      },
                                    },
                                    [_vm._v("Action Boards")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "header-utility__dropdown-item",
                                      attrs: {
                                        href: "https://ws.vixio.com/obligations",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                      },
                                    },
                                    [_vm._v("Obligations Library")]
                                  ),
                                ]
                              : [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "header-utility__dropdown-item header-utility__dropdown-item--disabled",
                                    },
                                    [_vm._v("Triage")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "header-utility__dropdown-item header-utility__dropdown-item--disabled",
                                    },
                                    [_vm._v("Action Boards")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "header-utility__dropdown-item header-utility__dropdown-item--disabled",
                                    },
                                    [_vm._v("Obligations Library")]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isAuthorize
                  ? _c(
                      "div",
                      {
                        staticClass: "header-utility",
                        on: {
                          mouseover: function ($event) {
                            _vm.profileOpen = true
                          },
                          mouseleave: function ($event) {
                            _vm.profileOpen = false
                          },
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "header-utility__btn header-utility__btn--icon",
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 18 18",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z",
                                    fill: "currentColor",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.profileOpen,
                                expression: "profileOpen",
                              },
                            ],
                            staticClass: "header-utility__dropdown",
                          },
                          [
                            _vm._l(
                              _vm.profileMenu.submenu,
                              function (item, index) {
                                return _c(
                                  "nuxt-link",
                                  {
                                    key: index,
                                    staticClass:
                                      "header-utility__dropdown-item",
                                    attrs: { to: item.link },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.title) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "header-utility__dropdown-item header-utility__dropdown-item--logout",
                                on: { click: _vm.handleLogout },
                              },
                              [_vm._v("\n              Logout\n            ")]
                            ),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAuthorize
                  ? _c(
                      "nuxt-link",
                      {
                        staticClass:
                          "header-utility__btn header-utility__btn--login",
                        attrs: { to: "/login" },
                      },
                      [_vm._v("\n          LOGIN\n        ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "header-primary__mobile" }, [
              !_vm.showSearch
                ? _c(
                    "div",
                    {
                      staticClass: "header-primary__mobile-search",
                      on: {
                        click: function ($event) {
                          _vm.showSearch = true
                        },
                      },
                    },
                    [_c("Icon", { attrs: { icon: "search-black" } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showSearch
                ? _c(
                    "div",
                    {
                      staticClass: "header-primary__mobile-close",
                      on: {
                        click: function ($event) {
                          _vm.showSearch = false
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icons/i_close.svg"),
                          alt: "close",
                        },
                      }),
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "header-primary__mobile-burger" },
                    [
                      _c("Burger", {
                        attrs: { "props-handle-click": _vm.openSidebar },
                      }),
                    ],
                    1
                  ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-secondary" }, [
        _c(
          "div",
          { staticClass: "container header-secondary__inner" },
          [
            _c("nav", { staticClass: "header-secondary__nav" }, [
              _c(
                "ul",
                { staticClass: "header-secondary__list" },
                _vm._l(_vm.menu, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "header-secondary__item",
                      class: {
                        "header-secondary__item--restricted": _vm.checkAccess(
                          item.title
                        ),
                      },
                      on: {
                        mouseover: function ($event) {
                          return _vm.onOver(index)
                        },
                        mouseleave: _vm.onLeave,
                      },
                    },
                    [
                      item.tag
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: item.link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.title) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _c(
                            "nuxt-link",
                            {
                              attrs: {
                                to: item.link,
                                exact: item.link === "/",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.title) +
                                  "\n            "
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "slide" } }, [
                        item.submenu && _vm.activePoint === index
                          ? _c(
                              "ul",
                              { staticClass: "header-secondary__submenu" },
                              _vm._l(item.submenu, function (item2, k) {
                                return _c(
                                  "li",
                                  { key: k },
                                  [
                                    _c(
                                      "nuxt-link",
                                      { attrs: { to: item2.link } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item2.title) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.checkAccess(item.title)
                        ? _c("Tooltip", {
                            staticClass: "tip",
                            attrs: { size: "small" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.isAuthorize && _vm.viqEnabled
              ? _c(
                  "nuxt-link",
                  {
                    staticClass: "header-secondary__viq-link",
                    attrs: { to: "/viq", title: "VIQ — AI Research Assistant" },
                  },
                  [
                    _c("img", {
                      staticClass: "header-secondary__viq-logo",
                      attrs: {
                        src: require("@/assets/images/viq-logo.svg"),
                        alt: "VIQ",
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAuthorize
              ? _c(
                  "div",
                  {
                    staticClass: "header-secondary__tools",
                    on: {
                      mouseover: function ($event) {
                        _vm.toolsOpen = true
                      },
                      mouseleave: function ($event) {
                        _vm.toolsOpen = false
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      { staticClass: "header-secondary__tools-btn" },
                      [
                        _vm._v("\n          MY TOOLS\n          "),
                        _c(
                          "svg",
                          {
                            staticClass: "header-secondary__tools-chevron",
                            class: { open: _vm.toolsOpen },
                            attrs: {
                              width: "10",
                              height: "6",
                              viewBox: "0 0 10 6",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1 1l4 4 4-4",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toolsOpen,
                            expression: "toolsOpen",
                          },
                        ],
                        staticClass: "header-secondary__tools-dropdown",
                      },
                      [
                        _vm.hasAccessTools
                          ? _c(
                              "nuxt-link",
                              {
                                staticClass: "header-secondary__tools-item",
                                attrs: { to: "/reportbuilder" },
                              },
                              [
                                _vm._v(
                                  "\n            Report Builder\n          "
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "header-secondary__tools-item header-secondary__tools-item--disabled",
                              },
                              [_vm._v("Report Builder")]
                            ),
                        _vm._v(" "),
                        _vm.hasAccessTools
                          ? _c(
                              "nuxt-link",
                              {
                                staticClass: "header-secondary__tools-item",
                                attrs: { to: "/reportbuilder-us" },
                              },
                              [
                                _vm._v(
                                  "\n            Report Builder (US)\n          "
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "header-secondary__tools-item header-secondary__tools-item--disabled",
                              },
                              [_vm._v("Report Builder (US)")]
                            ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isOpen
        ? _c("MobileHeader", {
            on: {
              close: function ($event) {
                _vm.isOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }